import { PhoneFilledIcon, Tooltip } from '@calizahq/react-components-v2'

export const CorporateLeadListColumns = [
  {
    Header: 'Company',
    accessor: 'companyName',
    width: 100,
  },
  {
    Header: 'First Name',
    accessor: 'firstName',
    width: 75,
  },
  {
    Header: 'Last Name',
    accessor: 'lastName',
    width: 75,
  },
  {
    Header: 'Email',
    accessor: 'email',
    width: 100,
  },
  {
    Header: 'Phone',
    accessor: 'phone',
    width: 75,
    Cell: ({ value }: { value: string }) => {
      return (
        <div className="flex underline mr-8">
          {value ? (
            <a href={`dialpad://${value}`} rel="noreferrer" target="_blank">
              <div className="flex flex-row">
                <div>
                  <Tooltip text="Call with Dialpad">
                    <PhoneFilledIcon className="w-6 mr-2" height={28} width={28} />
                  </Tooltip>
                </div>
                <div className="mt-1">{value}</div>
              </div>
            </a>
          ) : null}
        </div>
      )
    },
  },
  {
    Header: 'Units',
    accessor: 'numberOfUnits',
    width: 25,
  },
]
